import { render, staticRenderFns } from "./PedidosInternos.vue?vue&type=template&id=d416ac0e"
import script from "./PedidosInternos.vue?vue&type=script&lang=js"
export * from "./PedidosInternos.vue?vue&type=script&lang=js"
import style0 from "./PedidosInternos.vue?vue&type=style&index=0&id=d416ac0e&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports